import {dbotBlockApi} from "./business/Functions";
import {buildLog} from "./business/DbotHelperFunctions";

export function clickButton(payload) {
  console.log(payload.button);
  return {
    type: "DBOT_CLICK",
    payload,
    toLog: buildLog(payload.button)
  };
}


export function clickImage(src) {
  return {
    type: "IMAGE_CLICKED",
    toLog: {
      eventName: "imageClicked",
      elemId: src
    }
  };
}

export function clickInvestButton(src,index) {
  return {
    type: "INVEST_BUTTON_CLICKED",
    payload: src,
    toLog: {
      eventName: "dbotInvestButtonClicked",
      category: "dbot",
      tagValue: src,
      tagName: "investButton",
      elemId: index
    }
  };
}

export function addAndInitBlock(block, persistRecordsF, id) {
  let blockApi = dbotBlockApi(block);
  let records = id ? blockApi.processNode(id) : blockApi.initConversation();
  if (persistRecordsF) persistRecordsF(records);
  return {
    type: "ADD_AND_INIT_BLOCK",
    payload: {
      records: records,
      blockApi
    }
  };
}


export function clearAddAndInitGlobalBlock(block) {
  window.GLOBAL_BLOCK = block;
  return clearAddAndInitBlock(block);
}

export function clearAddAndInitBlock(block) {
  let blockApi = dbotBlockApi(block);
  let records = blockApi.initConversation();
  return {
    type: "CLEAR_ADD_AND_INIT_BLOCK",
    payload: {
      records,
      blockApi
    }
  };
}

export function loadRecords(records, storedPointers) {
  return {
    type: "LOAD_RECORDS",
    payload: {
      records : records ? records : [],
      storedPointers : storedPointers ? storedPointers : []
    }
  };
}


